import { motion } from 'framer-motion'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'

import albumEnzo3 from '@/assets/album-enzo3.webp'
import albumLencois from '@/assets/album-lencois.webp'
import albumCorrida from '@/assets/album-corrida.webp'
import albumAlexandra from '@/assets/album-alexandra.webp'
import albumEnzoBaby from '@/assets/album-enzo-baby.webp'
import albumHelena from '@/assets/album-helena.webp'
import albumParis from '@/assets/album-paris.webp'
import albumGiulia from '@/assets/album-giulia.webp'
import albumOdontologia from '@/assets/album-odontologia.webp'
import albumRoma from '@/assets/album-roma.webp'
import albumVeneza from '@/assets/album-veneza.webp'
import albumBaviera from '@/assets/album-baviera.webp'
import albumCostaAmalfitana from '@/assets/album-costa-amalfitana.webp'
import albumPatagonia from '@/assets/album-patagonia.webp'
import albumUnitedKingdom from '@/assets/album-united-kingdom.webp'
import albumLondon from '@/assets/album-london.webp'
import albumAustria from '@/assets/album-austria.webp'

const albumPhotos = [
  { id: 1, title: 'Aniversário Infantil', image: albumEnzo3, zoom: false },
  {
    id: 2,
    title: 'Viagem Lençóis Maranhenses',
    image: albumLencois,
    zoom: false,
  },
  { id: 3, title: 'Corrida 10K', image: albumCorrida, zoom: false },
  {
    id: 4,
    title: 'Formatura Ensino Fundamental',
    image: albumAlexandra,
    zoom: false,
  },
  { id: 5, title: 'Álbum de Bebê', image: albumEnzoBaby, zoom: false },
  { id: 6, title: 'Formatura ABC', image: albumHelena, zoom: false },
  { id: 7, title: 'Paris Versalhes', image: albumParis, zoom: false },
  { id: 8, title: 'Formatura Direito', image: albumGiulia, zoom: false },
  {
    id: 9,
    title: 'Formatura Odontologia',
    image: albumOdontologia,
    zoom: false,
  },
  { id: 10, title: 'Roma', image: albumRoma, zoom: false },
  { id: 11, title: 'Venice Marathon', image: albumVeneza, zoom: false },
  { id: 12, title: 'Baviera', image: albumBaviera, zoom: false },
  {
    id: 13,
    title: 'Costa Amalfitana',
    image: albumCostaAmalfitana,
    zoom: false,
  },
  { id: 14, title: 'Patagônia', image: albumPatagonia, zoom: true },
  { id: 15, title: 'United Kingdom', image: albumUnitedKingdom, zoom: true },
  { id: 16, title: 'London', image: albumLondon, zoom: true },
  { id: 17, title: 'Áustria', image: albumAustria, zoom: true },
]

const ProgramaSection = () => {
  return (
    <section id="o-que-e" className="w-full py-16 md:py-24 bg-background">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold italic text-foreground leading-tight">
            O que é o programa Parceria FotoLivro Store?
          </h2>

          <div className="space-y-5 text-base md:text-lg text-muted-foreground font-body leading-relaxed">
            <p>
              O Programa de Parceria FotoLivro Store permite que você transforme
              a experiência dos seus clientes, oferecendo álbuns de alta
              qualidade que valorizam o seu trabalho.
            </p>

            <p>
              Se você é fotógrafo, suas fotos ganham vida e destaque quando
              impressas em álbuns impecáveis. Se você tem um negócio ou
              comunidade, oferece algo que encanta e cria memórias reais para
              seus clientes ou seguidores.
            </p>

            <p>
              Ao indicar a FotoLivro Store, você se torna um parceiro de
              confiança, ajudando seus clientes a vivenciarem momentos
              inesquecíveis — e, ao mesmo tempo, recebe uma participação sobre
              cada álbum vendido, de forma simples e automática.
            </p>

            <p>
              Juntos, transformamos fotos digitais em experiências tangíveis que
              emocionam e permanecem por gerações.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Carrossel de Álbuns */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="max-w-6xl mx-auto px-12 md:px-20 mt-12"
      >
        <Carousel
          opts={{
            align: 'start',
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent className="-ml-4">
            {albumPhotos.map(album => (
              <CarouselItem
                key={album.id}
                className="pl-4 basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4"
              >
                <div className="aspect-square rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
                  <img
                    src={album.image}
                    alt={album.title}
                    className={`w-full h-full object-cover ${album.zoom ? 'scale-150' : ''}`}
                    loading="lazy"
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="-left-4 md:-left-10" />
          <CarouselNext className="-right-4 md:-right-10" />
        </Carousel>
      </motion.div>
    </section>
  )
}

export default ProgramaSection
